/**
 * Anciennes adresses de liste de la console (menu d'avant les onglets,
 * octobre 2026) → leur onglet. Les favoris et les liens internes qui y mènent
 * encore arrivent au bon endroit au lieu d'une page introuvable.
 * Les fiches de détail (`/lecons/:id`…) gardent leur adresse : non listées.
 */
export const ANCIENNES_ADRESSES: Record<string, string> = {
  '/': '/tableau-de-bord',
  '/admin/user-stats': '/tableau-de-bord/utilisateurs',
  '/credits/suivi': '/tableau-de-bord/credits',
  '/revenus': '/tableau-de-bord/revenus',
  '/publicite/activite': '/tableau-de-bord/publicite',
  '/agent': '/tableau-de-bord/suklu-ai',
  '/classes': '/contenu/referentiel/classes',
  '/matieres': '/contenu/referentiel/matieres',
  '/chapitres': '/contenu/programme',
  '/lecons': '/contenu/programme',
  '/exercices': '/contenu/programme',
  '/videos': '/contenu/referentiel/videos',
  '/thumbnails': '/contenu/referentiel/vignettes',
  '/school-books': '/contenu/referentiel/livres',
  '/book-chapters': '/contenu/manuels',
  '/book-lessons': '/contenu/manuels',
  '/book-exercises': '/contenu/referentiel/exercices-manuels',
  // Sous-onglets de Programme et Manuels avant l'explorateur (lot 2).
  '/contenu/programme/classes': '/contenu/referentiel/classes',
  '/contenu/programme/matieres': '/contenu/referentiel/matieres',
  '/contenu/programme/chapitres': '/contenu/programme',
  '/contenu/programme/lecons': '/contenu/programme',
  '/contenu/programme/exercices': '/contenu/programme',
  '/contenu/programme/videos': '/contenu/referentiel/videos',
  '/contenu/programme/vignettes': '/contenu/referentiel/vignettes',
  '/contenu/manuels/livres': '/contenu/referentiel/livres',
  '/contenu/manuels/chapitres': '/contenu/manuels',
  '/contenu/manuels/lecons': '/contenu/manuels',
  '/contenu/manuels/exercices': '/contenu/referentiel/exercices-manuels',
  '/featured-videos': '/contenu/a-la-une',
  '/admin/mobile-users': '/utilisateurs/eleves-parents',
  '/verification/enseignants': '/utilisateurs/enseignants',
  '/verification/ia': '/utilisateurs/enseignants',
  '/admin/users': '/utilisateurs/equipe/comptes',
  '/admin/invitation-codes': '/utilisateurs/equipe/invitations',
  '/admin/moderation-messagerie': '/moderation/a-traiter',
  '/admin/ia-signalements': '/moderation/a-traiter',
  '/admin/exercise-reports': '/moderation/a-traiter',
  '/payments/pispi': '/paiements/recus',
  '/payments/pispi/paiements': '/paiements/recus',
  '/payments/pispi/clients': '/paiements/clients',
  '/payments': '/paiements/recus',
  '/payments/dashboard': '/tableau-de-bord/revenus',
  '/payments/packages': '/paiements/packs',
  '/payments/credits': '/paiements/credits',
  '/parrainage': '/paiements/parrainage',
  '/campagnes': '/croissance/campagnes',
  '/notifications-test': '/croissance/campagnes',
  '/pricing': '/reglages/tarifs',
  '/credit-config': '/reglages/couts-ia',
  '/publicite/config': '/reglages/publicite',
  '/agent/profiles': '/reglages/suklu-ai/profils',
  '/agent/secrets': '/reglages/suklu-ai/cles',
  '/agent/playground': '/reglages/suklu-ai/bac-a-essai',
  '/payments/pispi/configuration': '/reglages/pispi/configuration',
  '/payments/pispi/compte': '/reglages/pispi/compte',
  '/verification/documents': '/reglages/enseignants',
  '/admin/logs': '/technique/journaux',
  '/admin/activity': '/technique/audit',
  '/admin/crash-reports': '/technique/crashs',
  '/env-sync': '/technique/donnees/copier',
  '/env-sync/history': '/technique/donnees/historique',
  '/data-migration': '/technique/donnees/importer',
  '/payments/pispi/simulateur': '/technique/simulateur-pispi',
  '/payments/pispi/notifications': '/technique/webhooks',
};
